import { useMemo } from 'react';
import compact from 'lodash/compact';
import { useSelectedIssueId } from '../../controllers/issue/selectors/properties/hooks.tsx';

export const useExcludedIssueIds = (): number[] => {
	const selectedIssueId = useSelectedIssueId();
	return useMemo(() => compact([selectedIssueId]), [selectedIssueId]);
};
